export default __webpack_public_path__ + "static/media/banner-01.7ae61187.png";